var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewRelease(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "new_release",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12840",
    "data-name": "Rectangle 12840",
    width: 24,
    height: 24,
    fill: "#fef1e8",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47706",
    "data-name": "Path 47706",
    d: "M15,3a1,1,0,0,1,1,1v6h1.59a1,1,0,0,1,.71,1.71L15.71,14.3a1,1,0,0,1-1.41,0l-2.59-2.59a1,1,0,0,1,.7-1.71H14V4A1,1,0,0,1,15,3ZM6,19.59A1.408,1.408,0,0,0,7.41,21h9.17a1.408,1.408,0,0,0,1.41-1.41c0-.72-.44-1.03-1-1.59h3a2.006,2.006,0,0,0,2-2V14a1,1,0,0,0-2,0v2H4V5h7a1,1,0,0,0,0-2H4A2.006,2.006,0,0,0,2,5V16a2.006,2.006,0,0,0,2,2H7C6.45,18.55,6,18.87,6,19.59Z",
    fill: "#f60"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewRelease);
export default __webpack_public_path__ + "static/media/new_release.b9c42798c9b44d244895474ea550ce25.svg";
export { ForwardRef as ReactComponent };